import getPriceForCurrency from "@helpers/getPriceForCurrency"
import { getOnboardingContext, isHomeFlow } from "@helpers/localStorage"
import localizeCurrency from "@helpers/localizeCurrency"
import { useTranslation } from "react-i18next"
import { Plan, StripePrice } from "src/types"

interface DisclaimerProps {
  plan: Plan
  fullPrice: StripePrice | undefined
  currency: string
}

export default function Disclaimer({
  plan,
  fullPrice,
  currency,
}: DisclaimerProps) {
  const { t } = useTranslation()
  const context = getOnboardingContext()
  const plansCopyKey =
    context === "cars"
      ? "pages.checkout.plansCars"
      : context === "pets"
        ? "pages.checkout.plansPets"
        : isHomeFlow()
          ? "pages.checkout.plansHome"
          : "pages.checkout.plans"

  const priceData = getPriceForCurrency(fullPrice, currency)

  if (!priceData) return null

  const formattedPrice = localizeCurrency({
    amountInCents: priceData.price,
    currency: priceData.currency,
  })

  if (!formattedPrice) return null

  const getDisclaimerKey = () => {
    switch (plan) {
      case "weekly":
        return `${plansCopyKey}.disclaimerWeekly`
      case "monthly":
        return `${plansCopyKey}.disclaimerMonthly`
      case "quarterly":
        return `${plansCopyKey}.disclaimerQuarterly`
      case "yearly":
        return `${plansCopyKey}.disclaimerYearly`
      case "one-time":
        return `${plansCopyKey}.disclaimerOneTime`
    }
  }

  const translationKey = getDisclaimerKey()

  const text = t(translationKey, { price: formattedPrice })

  return (
    <div className="bg-card-elevated rounded-2xl px-6 py-5 text-center">
      <p className="text-text-secondary text-sm leading-relaxed">{text}</p>
    </div>
  )
}
